// extracted by mini-css-extract-plugin
module.exports = {"large-button":"Button_large-button__fNdRs","small-button":"Button_small-button__S3ba2","link-button":"Button_link-button__Ui0ZK"};